(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name adminCrewBatchers.factory:CrewBatchFactory
     *
     * @description
     *
     */
    angular
        .module('renewals')
        .factory('RenewalsFactory', RenewalsFactory);

    function RenewalsFactory() {


        function CrewTypeDTO() {
            this.crewTypeCode = null;
            this.crewTypeDescription = null;

        }

        function ScheduleTrainingRequest() {
            this.crewProfileId = null;
            this.validationExpiryDateString = null;
            this.validationCode = null;
        }

        function ValidationTypeDTO() {
            this.code = null;
            this.description = null;
        }

        function ValidationByTypeRequest() {
            this.validationType = null;
            this.crewType = null;
        }

        function ValidationDTO() {
            this.id = null;
            this.description = null;
        }

        function FleetTypesDTO() {
            this.modelNumber = null;
        }

        function BaseDTO() {
            this.airPortCode = null;
        }

        function RenewalsSearchRequest() {
            this.crewBase = null;
            this.aircraftType = null;
            this.crewId = null;
            this.crewType = null;
            this.validationType = null;
            this.validation = null;
            this.dateOfIssue = null;
            this.dateOfExpiry = null;
            this.startPosition = null;
            this.pageSize = null;
            this.acmi = null;
            this.employerHub = null;
        }

        function CrewSearchExpiryDTO() {
            this.crewBase = null;
            this.aircraftType = null;
            this.crewId = null;
            this.crewType = null;
            this.validationType = null;
            this.validation = null;
            this.dateOfIssue = null;
            this.dateOfExpiry = null;
            this.warningDate = null;
            this.crewName = null;
            this.validationId = null;
            this.alreadyAssigned=false;
            this.trainingProgramId = null;
            this.plannedDate = null;
        }

        function CrewDTO() {
            this.crewId = null;
            this.crewProfileId = null;
            this.crewName=null;
            this.crewType=null;
        }


        function FormatGridDataSearchResponse(renewals) {
            var formattedList = [];
            angular.forEach(renewals, function (renewal) {
                var crewTypeDTO = new CrewSearchExpiryDTO();

                crewTypeDTO.crewBase = renewal.crewBase;
                crewTypeDTO.aircraftType = renewal.aircraftType;
                crewTypeDTO.crewId = renewal.crewId;
                crewTypeDTO.crewType = renewal.crewType;
                crewTypeDTO.validationType = renewal.validationType;
                crewTypeDTO.validation = renewal.validation;
                crewTypeDTO.dateOfIssue = renewal.dateOfIssue;
                crewTypeDTO.dateOfExpiry = renewal.dateOfExpiry;
                crewTypeDTO.crewType = renewal.crewType;
                crewTypeDTO.warningDate = renewal.warningDate;
                crewTypeDTO.crewName = renewal.crewName;
                crewTypeDTO.validationId = renewal.validationId;
                crewTypeDTO.alreadyAssigned=renewal.alreadyAssigned;
                crewTypeDTO.trainingProgramId = renewal.trainigProgramId;
                crewTypeDTO.plannedDate = renewal.plannedDate;

                formattedList.push(crewTypeDTO);
            });

            return formattedList;

        }

        function FormatCrewTypeResponse(crewTypes) {
            var formattedList = [];
            angular.forEach(crewTypes, function (crewType) {
                var crewTypeDTO = new CrewTypeDTO();

                crewTypeDTO.crewTypeCode = crewType.crewTypeCode;
                crewTypeDTO.crewTypeDescription = crewType.crewTypeDescription;

                formattedList.push(crewTypeDTO);
            });
            return formattedList;
        }


        function FormatValidationTypeResponse(validationType) {
            var formattedList = [];
            angular.forEach(validationType, function (validationType) {
                var vType = new ValidationTypeDTO();
                vType.code = validationType.code;
                vType.description = " "+validationType.description;

                formattedList.push(vType);
            });
            return formattedList;
        }


        function PopulateValidationSearchRequest(postData) {
            var validationByTypeRequest = new ValidationByTypeRequest();
            validationByTypeRequest.validationType = postData.validationType.code;
            validationByTypeRequest.crewType = postData.crewTypeCode;
            return validationByTypeRequest;
        }

        function FormatValidationsResponse(validations) {
            var formattedList = [];
            angular.forEach(validations, function (validation) {
                var vd = new ValidationDTO();
                vd.id = validation.id;
                vd.description = validation.description;

                formattedList.push(vd);
            });
            return formattedList;
        }

        function FormatFleetTypeResponse(fleetTypes) {
            var formattedList = [];
            angular.forEach(fleetTypes, function (fleet) {
                var fl = new FleetTypesDTO();
                fl.modelNumber = fleet.modelNumber;
                formattedList.push(fl);
            });
            return formattedList;
        }

        function FormatCrewBaseResponse(crewBases) {
            var formattedList = [];
            angular.forEach(crewBases, function (base) {
                var bs = new BaseDTO();
                bs.airPortCode = base.airPortCode;
                formattedList.push(bs);
            });
            return formattedList;
        }

        function PopulateRenewalsSearchRequest(postData) {
            var request = new RenewalsSearchRequest();
            request.crewBase = postData.crewBase != null ? postData.crewBase.airPortCode : null;
            request.aircraftType = postData.aircraftType != null ? postData.aircraftType.modelNumber : null;
            request.crewId = postData.crewId;
            request.crewType = postData.crewType != null ? postData.crewType.crewTypeCode : null;
            request.validationType = postData.validationType != null ? postData.validationType.code : null;
            request.validation = postData.validation != null ? postData.validation.id : null;
            request.dateOfIssue = postData.dateOfIssue;
            request.dateOfExpiry = postData.dateOfExpiry;
            request.startPosition = postData.startPosition;
            request.pageSize = postData.pageSize;
            if (postData.includeAcmiCrew && postData.includeAcmiCrew.value) {
                request.acmi = postData.includeAcmiCrew.value === 'Yes' ? 'Y' : 'N';
            } else {
                request.acmi = null;
            }
            request.employerHub = postData.employerHub != null ? postData.employerHub.hubCode : null;
            return request;
        }

        function GetNewRenewal() {
            return new RenewalsSearchRequest();
        }

        function scheduleTrainingSearchRQ(selectedTrainingExp) {
            var trainingRQ = new ScheduleTrainingRequest();
            trainingRQ.crewProfileId = selectedTrainingExp.crew.crewProfileId;
            trainingRQ.validationCode = selectedTrainingExp.validation;
            trainingRQ.validationExpiryDateString = selectedTrainingExp.dateOfExpiry;
            return trainingRQ
        }

        function getCrewFormatted(crew) {
            var nCrew = new CrewDTO();
            nCrew.crewId = crew.crewId;
            nCrew.crewProfileId = crew.crewProfileId;
            nCrew.crewName = crew.firstName + " " + crew.lastName;
            nCrew.crewType = crew.crewType;
            return nCrew
        }

        var createTrainingForAssign = function (training) {
            return {
                trainingSlotId: training.slotId,
                trainingSlotProramId:  null,
                trainingProgramId:  training.programId,
                trainingProgramDetailId: training.programDetailId,
                startDateZulu: training.date,
                startTimeZulu: training.startTime
            };
        };

        return {
            formatCrewTypeResponse: FormatCrewTypeResponse,
            formatValidationTypeResponse: FormatValidationTypeResponse,
            formatValidationsResponse: FormatValidationsResponse,
            formatFleetTypeResponse: FormatFleetTypeResponse,
            formatCrewBaseResponse: FormatCrewBaseResponse,
            formatGridDataSearchResponse: FormatGridDataSearchResponse,
            getNewRenewal: GetNewRenewal,
            populateValidationSearchRequest: PopulateValidationSearchRequest,
            populateGridDataSearchRequest: PopulateRenewalsSearchRequest,
            scheduleTrainingSearchRQ: scheduleTrainingSearchRQ,
            getCrewFormatted: getCrewFormatted,
            createTrainingForAssign:createTrainingForAssign
        }
    }
})();
